export const EVENTS_RESET_STATE = 'EVENTS_RESET_STATE';
export const EVENTS_CURRENT_ITEM = 'EVENTS_CURRENT_ITEM';

export const EVENTS_REQUEST_LOADING = 'EVENTS_REQUEST_LOADING';
export const EVENTS_REQUEST_SUCCESS = 'EVENTS_REQUEST_SUCCESS';
export const EVENTS_REQUEST_FAILED = 'EVENTS_REQUEST_FAILED';

export const EVENTS_CURRENT_ACTION = 'EVENTS_CURRENT_ACTION';
export const EVENTS_RESET_ACTION = 'EVENTS_RESET_ACTION';